<template>
  <div class="tabs-default">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'tabs',
  props: {
    directNavigation: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
